import { AbstractLoader, AbstractLoaderOptions, registerLoader } from "./AbstractLoader.js";

export interface ScriptLoaderOptions extends AbstractLoaderOptions {
    async?: boolean;
    module?: boolean;
}

export class ScriptLoader extends AbstractLoader<HTMLScriptElement, ScriptLoaderOptions>{
    private _script: HTMLScriptElement;

    constructor(url: string, options: ScriptLoaderOptions = null) {
        super(url, options);

        var script = document.createElement("script");
        if (options.module === true) {
            script.type = "module";
            //"text/javascript"
        }
        script.async = this._options.async;

        script.onerror = (e) => {
            this.reject(e)
        }

        script.onload = async (e) => {
            this.resolve(script);
        }

        script.onprogress = (e: ProgressEvent) => {
            this._onProgress.dispatch({
                event: e,
                delta: 0,
                loaded: e.loaded,
                total: e.total
            });
        }

        script.src = url;
        document.head.appendChild(script);

        this._script = script;
    }

    public cancel(reason: any = null): this {
        this._script.onerror = null;
        this._script.src = "";
        this._script.removeAttribute("src");
        super.cancel(reason);
        return this;
    }

    protected finish(): void {
        var script = this._script;
        script.onerror = null;
        script.onload = null;
        script.onprogress = null;
        this._script = null;

        super.finish();
    }

    protected defaultOptions(): ScriptLoaderOptions {
        return {
            async: true
        };
    }
}

registerLoader("script", ScriptLoader);